"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class UserAccountTypes {
}
exports.UserAccountTypes = UserAccountTypes;
//# sourceMappingURL=UserAccountTypes.js.map